import React, { Component, Fragment } from 'react'
import noop from 'lodash/noop'
import { Trans } from '@lingui/react'

import SVGInline from 'react-svg-inline'
import SuccessMarkIcon from 'client/shared/icons/success-mark.svg'
import Button from 'client/shared/blocks/button'

import { BookSerialProps } from 'client/shared/types/resource'

import './wishlist-button.styl'

type Props = {
  book: BookSerialProps
  onButtonClick: () => void
  loading: boolean
}

export class WishlistButton extends Component<Props> {
  render(): JSX.Element {
    const {
      book: { in_wishlist },
      onButtonClick,
      loading,
    } = this.props

    return (
      <Button
        pseudo
        disabled={in_wishlist}
        loading={loading}
        kind="transparent"
        type="inline"
        onClick={in_wishlist ? noop : onButtonClick}
        className={`wishlist-button ${
          in_wishlist ? 'wishlist-button_added' : ''
        }`}
      >
        {in_wishlist && (
          <Fragment>
            <SVGInline
              svg={SuccessMarkIcon}
              className="wishlist-button__success-mark"
            />
            <span className="wishlist-button__note">
              <Trans id="buttons.wishlist_note" />
            </span>
          </Fragment>
        )}
        {!in_wishlist && <Trans id="buttons.wishlist_add_button" />}
      </Button>
    )
  }
}
